module.exports = __webpack_public_path__ + "img/img3.adbb8c4f.jpg";